import { Component } from "@angular/core";
import { ToastType } from "src/app/enums/toast-type";
import { NotificationService } from "src/app/services/notification.service";

@Component({
  selector: "app-notification-bar",
  templateUrl: "./notification-bar.component.html",
  styleUrls: ["./notification-bar.component.scss"],
})
export class NotificationBarComponent {
  constructor(readonly notificationService: NotificationService) {}

  getNotificationStyleName(): string {
    const baseClass = "notification_";

    switch (this.notificationService.notificationType) {
      case ToastType.Success:
        return baseClass + "success";
      case ToastType.Error:
        return baseClass + "error";
      case ToastType.Info:
        return baseClass + "info";
      default:
        return baseClass;
    }
  }
}
